<template>
  <div class="container">
    <div class="p-header">
      <img class="suc-img" src="../assets/images/icon-suc.png"/>
      <div class="des">支付成功</div>
      <div class="amount">¥<span>{{orderInfo.real_pay}}</span></div>
      <div class="suc-btn" @click="toOrderDetail">查看订单</div>
    </div>
     <div class="card">
      <div class="fs-32 fw-bold al">支付有福利</div>
      <div class="flex-row-bc" v-if="orderBonus && orderBonus.icon" style="padding: .4rem 0 .2rem 0;border-bottom: .01rem solid rgba(0,0,0,0.06);">
        <div class="flex-row-sc">
          <img :src="orderBonus.icon" style="width: .56rem;"/>
          <div style="margin: 0 .1rem 0 .3rem">
            <div class="fs-32 fw-bold">{{orderBonus.bonus}}</div>
            <div style="color: #666;margin-top: .1rem">{{orderBonus.tips}}</div>
          </div>
        </div>
        <div class="suc-btn" @click="jumpToApp">去APP查看</div>
      </div>
      <div class="flex-row-bc" v-if="scoreInfo && scoreInfo.icon" style="padding: .4rem 0 .2rem 0;">
        <div class="flex-row-sc">
          <img :src="scoreInfo.icon" style="width: .56rem;"/>
          <div style="margin: 0 .1rem 0 .3rem">
            <div class="fs-32 fw-bold">{{scoreInfo.title}}</div>
            <div style="color: #666;margin-top: .1rem">{{scoreInfo.sub_title}}</div>
          </div>
        </div>
        <div class="suc-btn" @click="jumpToScore">立即查看</div>
      </div>
    </div>
    <div class="ad-list">
      <img v-for="(item,index) in adList" :key="index" :src="item.imageUrl" @click="adJump(item)"/>
    </div>
    <!-- 下单发券 -->
    <div class="notice_detail_alert coupon" @touchmove.prevent @click="showOrderCoupon = false" v-if="showOrderCoupon">
      <div class="notice_detail_content">
        <div class="title">
          <img src="../assets/images/order-coupon-title.png" width="100%" alt="">
        </div>
        <div class="body">
          <div class="list">
            <div class="item" v-for="(item,index) in orderCouponList" :key="index">
              <div class="flex-row-bc">
                <div class="flex-row-sc">
                  <img v-if="item.is_discount == 1" src="../assets/images/icon-coupon-discount.png" alt="">
                  <img v-else src="../assets/images/icon-coupon-reduce.png" alt="">
                  <div style="width: 2.9rem">
                    <div class="fs-32 fw-bold ellipse">{{item.name}}</div>
                    <div class="fs-22" style="color: #999;margin-top: .16rem">有效期至：{{item.finished_at}}</div>
                  </div>
                </div>
                <div class="price" v-if="item.is_discount == 1">
                  <span>{{item.amount}}折</span>
                </div>
                <div class="price" v-else>
                  ¥<span>{{item.amount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <img src="../assets/images/order-coupon-bottom.png" width="100%" alt="">
          <div class="jump-btn"><a href="https://dl.anlaiye.com">前往俺来也app下单使用</a></div>
        </div>
      </div>
    </div>
    <!-- 西游集卡 -->
    <div class="notice_detail_alert plus-card" v-if="showPlusCard" @touchmove.prevent @click="showPlusCard = false">
      <div class="notice_detail_content" @click="jumpToCard()">
        <img :src="plusCardInfo.bg" style="width: 100%;"/>
        <div class="info">
          <img :src="plusCardInfo.card" style="width: 3.35rem;margin:0 auto"/>
          <div class="tit">{{plusCardInfo.cardTitle}}</div>
          <span class="des" v-html="plusCardInfo.des"></span>
        </div>
        <div class="btn">
          <img :src="plusCardInfo.bt" style="width: 100%"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {actions} from '../store/actions'
  export default {
    name: 'PaySuccess',
    data () {
      return {
        orderId: '',
        orderInfo: {},
        orderCouponList: [],
        showOrderCoupon: false,
        showPlusCard: false,
        plusCardInfo: {},
        scoreInfo: {},
        orderBonus: {},
        adList: []
      }
    },
    created () {
      if(this.$route.query && this.$route.query.orderId){
        this.orderId = this.$route.query.orderId;
        this.getOrderDetail()
      }
    },

    methods: {
      getOrderDetail: function () {
        var _this = this
        var param = {
          order_id: this.orderId
        }
        actions.getOrderDetail(_this, param, function (data) {
          _this.orderInfo = data
          _this.getOrderCoupon() // 下单发券
          _this.getOrderCard() // 西游集卡
          _this.getScorePartake() // 下单预计得积分
          _this.getOrderBonus()
          _this.getAdList()
        })
      },
      toOrderDetail () {
        this.$router.replace({ name: 'OrderDetail' })
      },
      jumpToApp () {
        location.href = 'https://dl.anlaiye.com';
      },
      jumpToScore () {
        this.$router.replace({ name: 'MyScore' })
      },
      // 下单返券
      getOrderCoupon() {
        let _this = this
        let params = {
          school_id: _this.orderInfo.schoolId,
          order_id: _this.orderId
        }
        actions.getOrderCoupon(_this, params, function (res) {
          if(res && res.length > 0){
            _this.orderCouponList = res;
            _this.showOrderCoupon = true;
          }
        }, function () {

        })
      },
      // 下单预计得积分
      getScorePartake() {
        let _this = this
        let params = {
          pay_amount: _this.orderInfo.real_pay,
          event_code: 'score_order_new'
        }
        actions.getScorePartake(_this, params, function (res) {
          if(res){
            _this.scoreInfo = res;
          }
        }, function () {

        })
      },
      // 下单立减金
      getOrderBonus() {
        let _this = this
        let params = {
          school_id: _this.orderInfo.schoolId,
          order_id: _this.orderId
        }
        actions.getOrderBonus(_this, params, function (res) {
          if(res){
            _this.orderBonus = res;
          }
        }, function () {

        })
      },
      // 广告
      getAdList: function () {
        var _this = this
        var url
        let host = _this.$utils.getSpliceHost('adsvc')
        url = host + '/ad/app/getList.do'
        var params = {
          app_version: '10.0.1',
          client_type: 3,
          device_id: '123',
          time: new Date().getTime(),
          schoolId: _this.orderInfo.schoolId,
          locationId: '116'
        }
        _this.$http.post(url, params).then(function (response) {
          _this.adList = response.data.data.list
        }, function (response) {
          // _this.alert(response.message)
          // 响应错误回调
        })
      },
      adJump(item) {
        let obj = {type: item.type, data: item.data}
        this.jumpFun(obj)
      },
      //新埋点
      clickLog(jumpType,code){
        var _this = this;
        var params = {
          logDetails: [{
            uid: _this.$store.state.wxUid,
            refId:  _this.orderId,
            firstValue: _this.orderInfo.schoolId,
            secondValue: jumpType,
            createTime: new Date().getTime(),
            code: code,
          }]
        }
        actions.postLogAdd(_this, params, function (data) {
          // console.log('记录成功');
        }, function (data) {

        })
      },
      // 西游集卡和单单返
      getOrderCard() {
        let _this = this
        let params = {
          school_id: _this.orderInfo.schoolId,
          order_id: _this.orderId
        }
        actions.getOrderCard(_this, params, function (res) {
          if(res){
            res.des = res.des.replace(/\n/g, "<br />");
            _this.plusCardInfo = res;
            _this.showPlusCard = true;
            _this.clickLog(res.jump_type,'asa_order_paid_suspend')

          }
        }, function () {

        })
      },
      jumpToCard() {
        let item = {type: this.plusCardInfo.jump_type, data: this.plusCardInfo.jump_data}
        this.clickLog(item.type,'click_order_paid_suspend')
        this.jumpFun(item)
      },
      jumpFun(item){
        if (item.data && item.data != '{}') {
          var jump = JSON.parse(item.data)
          if (jump.isNeedLogin && jump.isNeedLogin == 'true') {
            var uid = this.$store.state.wxUid
            if (uid == 'null' || uid == '' || uid == null) { // 如果没有登录信息先跳转登录页
              this.$utils.toLogin(_this);
            }
          }
          if (item.type == 500072) {
            var obj = {
              category_name: jump.key_title,
              tag_id: jump.key_id,
              shopListType: 'tag'
            }
            this.$store.commit('changeState', obj)
            this.$router.push({name: 'ShopList'})
          } else if (item.type == 1022) {
            if (jump.url) {
              window.location.href = jump.url
            }
          } else if (item.type == 500071) {
            var obj = {
              shop_code: jump.key_id,
              shop_name: jump.key_title,
              showBlockType: 'orderDishes'
            }
            this.$store.commit('changeState', obj)
            this.$router.push({name: 'GoodsList'})
          } else if(item.type == 500066){
            this.$router.push({name: 'TagPage'})
          }
        }
      }
    }

  }
</script>

<style scoped>
.container {
  background: #f5f5f5;
  height: 100vh;
}
.container .p-header{
  height: 5.8rem;
  margin-top: -0.4rem;
  padding-top: 1rem;
  background: #fed600;
  border-radius: 50%/0.4rem;
  text-align: center;
  font-size: 0.32rem;
}
.container .amount{
  font-size: .64rem;
  font-weight: bold;
  margin-top: .2rem;
}
.container .amount span{
  font-size: .8rem;
}

.container .suc-img{
  width: .8rem;
  margin: 0 auto;
  /* margin-top: 2rem; */
}
.container .des {

}
.fs-60{
  font-size: .6rem;
}
.suc-btn{
  width: 1.6rem;
  height: .6rem;
  background: rgba(255,255,255,0.5);
  border-radius: .3rem;
  line-height: .6rem;
  text-align: center;
  font-size: .24rem;
  margin: .2rem auto 0;
  font-weight: bold;
}
.card{
  margin: 0 .32rem;
  padding: .32rem .32rem .1rem .32rem;
  background: #FFFFFF;
  border-radius: .2rem;
  margin-top: -1.08rem;
}
.card .suc-btn{
  background: linear-gradient( 135deg, #FFEC00 0%, #FED400 100%);
}
.ad-list{
  margin: 0 .32rem;
}
.ad-list img{
  width: 100%;
  border-radius: .2rem;
  margin-top: .2rem;
}




.notice_detail_alert.coupon .notice_detail_content{
  position: relative;
  width: 6.9rem;
  /* height: 7.38rem; */
}
.notice_detail_alert.coupon .body{
  margin: 0 .25rem;
  width: 6.4rem;
  /* height: 100%; */
  padding-top: 1.54rem;
  padding-bottom: 2rem;
  border-radius: .24rem;
  background-color: #FD533A;
}
.notice_detail_alert.coupon .title{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1.38rem;
  z-index: 1003;
}
.notice_detail_alert.coupon .bottom{
  position: absolute;
  bottom: 0;
  left: .25rem;
  right: .25rem;
  height: 2.34rem;
  z-index: 1003;
}
.notice_detail_alert.coupon .bottom .jump-btn{
  position: absolute;
  width: 4.13rem;
  height: .8rem;
  font-weight: 500;
  color: #FF3131;
  font-size: .32rem;
  bottom: .64rem;
  left: 1.14rem;
  line-height: .8rem;
  text-align: center;
  background-image: linear-gradient(#FDEDDE, #FDEBA9);
  border-radius: .48rem;
  z-index: 1004;
}
.notice_detail_alert.coupon .bottom .jump-btn a{
  color: #FF3131;
}
.notice_detail_alert.coupon .body .list{
    padding: 0 .2rem .2rem .2rem;
    max-height: 4rem;
    overflow-y: scroll;
}
.notice_detail_alert.coupon .body .list .item{
  background: #FFFFFF;
  border-radius: .2rem;
  padding: .2rem;
  margin-bottom: .2rem;
}
.notice_detail_alert.coupon .body .list .item img{
  width: 1.12rem;
  margin-right: .2rem;
}
.notice_detail_alert.coupon .body .list .item .price{
  color: #FD533A;
  font-size: .28rem;
  font-weight: 600;
}
.notice_detail_alert.coupon .body .list .item .price span{
  font-size: .48rem;
}

.plus-card .notice_detail_content{
  position: relative;
  width: 5.5rem;
  /* height: 635rpx; */
}
.plus-card .notice_detail_content .info{
  position: absolute;
  left: .4rem;
  right: .4rem;
  top: .4rem;
  text-align: center;
  margin: 0 auto;

}
.plus-card .notice_detail_content .info .tit{
  font-size: .34rem;
  font-weight: bold;
  color: #fff;
  padding: .2rem 0 .1rem 0;
}
.plus-card .notice_detail_content .info .des{
  font-size: .24rem;
  color: #fff;
}
.plus-card .notice_detail_content .btn{
  width: 5.5rem;
  margin-top: .3rem;
}
</style>



// WEBPACK FOOTER //
// PaySuccess1.vue?fee717a4